import React from "react";

export const ComposedChart = React.lazy(() => import("./composed"));
